import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  combineDragPassengers,
  errors,
  IRideDto,
  IRidePassengerRowBase,
  IRideUpdateResultDto,
  RideSoftValidationErrorResponse,
  SimpleResult,
} from "@ryde/shared";

import { useDragRidesPassengers } from "./use-drag-rides-passengers";

export const useDragPassengersMove = () => {
  const { t } = useTranslation();
  const { dropPassengersToRide } = useDragRidesPassengers();

  const dragMovePassengers = useEvent(
    async (
      passengerRowProps: IRidePassengerRowBase,
      rideTo: Partial<IRideDto>,
    ): Promise<
      SimpleResult<
        IRideUpdateResultDto | RideSoftValidationErrorResponse | undefined
      >
    > => {
      const rideFrom = passengerRowProps.rideDto;

      if (rideFrom.id === rideTo.id) {
        return new SimpleResult({
          error: t(errors.ride.cantDropToTheSameRide, { id: rideTo.id }),
        });
      }

      const passengerInfos = combineDragPassengers(passengerRowProps);

      if (!rideFrom.id || !rideTo.id) {
        return new SimpleResult({
          error: t(errors.ride.invalidDragDropRideData),
        });
      }

      if (!passengerInfos) {
        return new SimpleResult({
          error: t(errors.ride.invalidDragDropRideDataNoPassengersToDrop),
        });
      }

      return dropPassengersToRide(passengerInfos, rideFrom, rideTo);
    },
  );

  return { dragMovePassengers };
};
